<template>
  <div class="modal-window uts018">
    <header class="modal-header">
      <div class="tit">{{$i18nUtil.trans("title.TodoLinkedListModal.001","관련 과제/보드")}}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div
        class="info-txt"
        v-if="modalInfo.userChk == null || modalInfo.userChk"
      >
        {{ $i18nUtil.trans("message.TodoLinkedListModal.001","연결하기 버튼을 통해 관련 과제/보드를 추가로 연결할 수 있습니다.") }}
      </div>
      <button
        type="button"
        class="btn_link_add"
        @click="addLink()"
        v-if="modalInfo.userChk == null || modalInfo.userChk"
      >
        {{ $i18nUtil.trans("button.add","추가") }}
      </button>
      <div class="scroll">
        <ul>
          <li v-for="(link, index) in orderedlinkList" v-bind:key="index">
            <div class="top">
              <span v-if="link.groupKbn == 'PRO'">{{$i18nUtil.trans("entity.project","과제")}}</span>
              <span v-if="link.groupKbn == 'USER'">{{ $i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗") }}</span>
              <span v-if="link.groupKbn == 'CFRC'">{{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }}</span>
              <div v-if="link.paperId != ''" class="dividing_line_ty3"></div>
              <span v-if="link.paperId != '' && link.groupKbn == 'CFRC'">{{ link.categoryName }}</span>
              <span v-if="link.paperId != '' && link.groupKbn == 'PRO'">{{ link.projectName }}</span>
            </div>
            <div v-if="link.paperId == '' && link.groupKbn == 'CFRC'" class="tit ell-singleline">{{ link.categoryName }}</div>
            <div v-if="link.paperId == '' && link.groupKbn == 'PRO'" class="tit ell-singleline">{{ link.projectName }}</div>
            <div v-else class="tit ell-singleline">{{ link.paperTitle }}</div>
            <button type="button" @click="removeLinkConfirm(link.linkId)" v-if="modalInfo.userChk == null || modalInfo.userChk">
              {{ $i18nUtil.trans("button.terminateConn","연결 해제") }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import todoLinkedModal2 from "./TodoLinkedModal2.vue";

export default {
  components: {
    Datepicker,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.getLinkList();
  },
  created() {
    EventBus.$off("refreshTodoLinkedListModal2");
    EventBus.$on("refreshTodoLinkedListModal2", (payload) => {
      this.getLinkList();
    });
  },
  computed:{
    orderedlinkList : function(){
      return _.orderBy(this.linkList, 'linkId', 'desc');
    }
  },
  data() {
    return {
      date: new Date(this.$moment()),
      show: false,
      error: false,
      linkList: null,
    };
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    getLinkList() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/todo/getLinkList",
        method: "post",
        params: {
          todoId: this.modalInfo.todoId,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          obj.linkList = res.result;
          console.log(obj.linkList);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    addLink() {
      const modalInfo = {
        name: "todoLinkedModal2",
        obj: this.$modal,
        component: todoLinkedModal2,
        width: "800px",
        height: "516px",
        todoId: this.modalInfo.todoId,
        parents: "TodoLinkedListModal2",
      };
      this.showModal(modalInfo);
    },
    removeLinkConfirm(param) {
      console.log(param);
      this.showConfirmDialog(
        { width: "400px" },
        this.$i18nUtil.trans("title.dialog.notice","알림"),
        this.$i18nUtil.trans("AB081"),
        this.$i18nUtil.trans("button.terminateConn","연결 해제"),
        this.removeLink,
        param,
        this.$i18nUtil.trans("button.dialog.cancel","취소")
      );
    },
    removeLink(param) {
      console.log("removeLink");
      let obj = this;
      let reqData = {
        url: "/api/copaper/todo/removeLink",
        method: "post",
        params: {
          linkId: param.modalParam.toString(),
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          obj.getLinkList();
          EventBus.$emit("board_TodoInfo_getLinkList", param.modalParam);
          EventBus.$emit("refreshTodoNewPage");
          EventBus.$emit("refreshTodoBoard");
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.uts004 .scroll {
  overflow-y: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/todo/popup/TodoLinkedListModal2.vue